// components/ArchivedStickyNotes.js
import {
    Box,
    Grid,
    Typography,
    CircularProgress,
} from '@material-ui/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import NoteStickyIndividual from './individualStickynote';

export default function ArchivedStickyNotes({ fetchNotesL, userSession }) {
    const [archivedNotes, setArchivedNotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);

    const fetchArchivedNotes = async () => {
        try {
            setLoading(true);
            const res = await axios.post(`${REST_API_END_POINT}tickets/get-archived-sticky-notes`, {
                userId: userSession?.user_id
            });

            if (res.data?.status === 1 && Array.isArray(res.data.data)) {
                setArchivedNotes(res.data.data);
            } else if (res.data?.status === 1 && res.data.data) {
                setArchivedNotes([res.data.data]);
            } else {
                setArchivedNotes([]);
            }
        } catch (error) {
            console.error("Failed to fetch archived notes", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchArchivedNotes();
    }, [refresh]);

    return (
        <Box>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                    <CircularProgress />
                </Box>
            ) : archivedNotes.length === 0 ? (
                <Box sx={{ mt: 6, textAlign: 'center' }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#999' }}>
                        🗃️ No archived sticky notes
                    </Typography>
                    <Typography variant="subtitle1" sx={{ mt: 1, color: '#aaa' }}>
                        Archived notes will appear here
                    </Typography>
                </Box>
            ) : (
                <>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                        Archived Notes
                    </Typography>
                    <Grid container spacing={3}>
                        {archivedNotes.map((note) => (
                            <Grid item xs={12} sm={6} md={6} key={note.id}>
                                <NoteStickyIndividual
                                    fetchNotesL={fetchNotesL}
                                    note={note}
                                    noteId={note.id}
                                    initialContent={note.sticky_note}
                                    initialPrivate={note.is_private}
                                    initialColor={note?.color}
                                    userName={note.user_name}
                                    updatedOn={note.updated_on}
                                    addedOn={note.timestamp}
                                    updatedName={note.updated_by_name}
                                    isReadOnly={false}
                                    onRefreshArchived={() => setRefresh(prev => !prev)}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </>
            )}
        </Box>
    );
}
